import { useTranslation } from 'react-i18next';

import { DataPanel } from '@/ui';
import type { Caller } from '@/signalr';
import { CallerFullNamePanel } from './CallerFullNamePanel';
import { PhoneNumberListPanel } from './PhoneNumberListPanel';

export type WebAppCallerInfoPanelProps = {
  incidentId: string;
  incidentIsReadOnly: boolean;
  caller: Caller;
};

export function WebAppCallerInfoPanel({ incidentId, incidentIsReadOnly, caller }: WebAppCallerInfoPanelProps) {
  const { t } = useTranslation();

  return (
    <DataPanel header={t('Incident_InfoPanel_InfoAboutCallerHeader')}>
      <CallerFullNamePanel incidentId={incidentId} callerFullName={caller.fullname} editable={!incidentIsReadOnly} />

      <PhoneNumberListPanel incidentId={incidentId} phoneNumbers={caller.phoneNumbers} editable={!incidentIsReadOnly} />
    </DataPanel>
  );
}
